// extracted by mini-css-extract-plugin
export default {"details":"subscription_details__+4MjP","pricingTab":"subscription_pricingTab__S0YOw","first":"subscription_first__bI0VP"};